if (!customElements.get('size-calculator')) {
    customElements.define(
        'size-calculator',
        class SizeCalculator extends HTMLElement {

            constructor() {
                super();
                this.detailsContainer = document.querySelector('.icon-search').closest('details');
                this.addEventListener("click", function (e) {

                    this.detailsContainer.setAttribute('open', true);
                    trapFocus(
                        this.detailsContainer.querySelector('[tabindex="-1"]'),
                        this.detailsContainer.querySelector('input:not([type="hidden"])')
                    );
                });
            }

        });
}